import { colorFromVehicle } from '../vehicle'

const lineFromVehicle = (vehicle) => {
  switch (vehicle) {
    case 'train':
    case 'subway':
    case 'cartrain':
    case 'nighttrain':
    case 'tram':
    case 'cablecar':
    case 'bus':
    case 'busferry':
    case 'nightbus':
      return lineAppearance(LineStyle.Solid, LineWidth.Regular, colorFromVehicle(vehicle))

    case 'plane':
    case 'flight':
    case 'helicopter':
    case 'ferry':
    case 'carferry':
      return lineAppearance(LineStyle.Solid, LineWidth.Bold, colorFromVehicle(vehicle))

    case 'transfer':
    case 'walk':
    case 'foot':
      // TODO (Angus): Avoid hardcoding the color here, since we may want to change it in the future
      return lineAppearance(LineStyle.Dotted, LineWidth.Regular, 'light-grey')

    case 'shuttle':
    case 'rideshare':
    case 'taxi':
    case 'animal':
    case 'towncar':
    case 'bicycle':
    case 'cycle':
    case 'car':
    case 'none': // TODO (simon): adding 'none' as vehical type so it doesn't wig out on bad data
    case 'unknown':
      return lineAppearance(LineStyle.Solid, LineWidth.Regular, colorFromVehicle(vehicle))

    default:
      throw new Error(`Unrecognised vehicleKind ${vehicle}`)
  }
}

const lineAppearance = (style, width, color) => ({ style, width, color })

const LineStyle = {
  Solid: 'solid',
  Dotted: 'dotted',
}

const LineWidth = {
  Regular: 'regular',
  Bold: 'bold',
}

export {
  LineStyle,
  LineWidth,
  lineFromVehicle,
  lineAppearance,
}
